import React, {Component} from 'react'
import { Link, NavLink } from 'react-router-dom'
import {uniqueId} from 'lodash'
import { PushContent } from './../../../../components'
import { BaseStyle } from './../../../../styles'
import Router from './../../../../services/Router'

export default class Base extends Component {
  state = {
    push: {},
    categories: {},
    background: '',
  }

  componentDidMount() {
  }

  render() {
    const { push, categories, type, load } = this.props
    const picture = push && push.picture ? push.picture : ''
    return (
      <div className={`panel-inner ${BaseStyle(picture, load)}`}>
        <div className="flex panel-content">
          <div className="panel-inner--categories flex">
            {
              categories && (
                categories.map((category, index) => (
                  <div className="panel-inner--category category" key={uniqueId(category.name)}>
                    <h2 className="category-name">{ category.name }</h2>
                    <ul className="reset">
                    {
                      category.menu && category.menu.map((item) => (
                        <li className="category-item" key={uniqueId(category.label)}><NavLink to={item.url} >{ item.label }</NavLink></li>
                      ))
                    }
                    </ul>
                    {
                      type === 'models' && index === 0 && (
                        <Link to={Router.models.path} className="link-all"> All models</Link>
                      )
                    }
                  </div>
                ))
              )
            }
            {
              type === 'brand' &&(
                <div className="panel-inner--category category">
                    <h2 className="category-name">Charity</h2>
                    <ul className="reset">
                      <li className="category-item"><NavLink to="/brand/charity" >Paris Brain Institute</NavLink></li>
                    </ul>
                </div>
              )
            }
          </div>
          <div className="panel-inner--push">
            {
              push && (
                <PushContent {...push} />
              )
            }
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Panel/Base.js